import { CSSProperties } from "react";

// const LoadingCpn = ({
//   className,
//   style,
// }: {
//   className?: string;
//   style?: CSSProperties;
// }): JSX.Element => {
//   return (
//     <svg
//       style={{ ...style }}
//       className={`${className || ''}`}
//       xmlns='http://www.w3.org/2000/svg'
//       viewBox='0 0 200 200'
//     >
//       <radialGradient
//         id='a12'
//         cx='.66'
//         fx='.66'
//         cy='.3125'
//         fy='.3125'
//         gradientTransform='scale(1.5)'
//       >
//         <stop offset='0' stopColor='#BA68C8'></stop>
//         <stop offset='.3' stopColor='#BA68C8' stopOpacity='.9'></stop>
//         <stop offset='.6' stopColor='#BA68C8' stopOpacity='.6'></stop>
//         <stop offset='.8' stopColor='#BA68C8' stopOpacity='.3'></stop>
//         <stop offset='1' stopColor='#BA68C8' stopOpacity='0'></stop>
//       </radialGradient>
//       <circle
//         style={{ transformOrigin: 'center', WebkitTransformOrigin: 'center' }}
//         fill='none'
//         stroke='url(#a12)'
//         strokeWidth='14'
//         strokeLinecap='round'
//         strokeDasharray='200 1000'
//         strokeDashoffset='0'
//         cx='100'
//         cy='100'
//         r='70'
//       >
//         <animateTransform
//           type='rotate'
//           attributeName='transform'
//           calcMode='spline'
//           dur='2'
//           values='360;0'
//           keyTimes='0;1'
//           keySplines='0 0 1 1'
//           repeatCount='indefinite'
//         ></animateTransform>
//       </circle>
//       <circle
//         style={{ transformOrigin: 'center', WebkitTransformOrigin: 'center' }}
//         fill='none'
//         opacity='.2'
//         stroke='#BA68C8'
//         strokeWidth='14'
//         strokeLinecap='round'
//         cx='100'
//         cy='100'
//         r='70'
//       ></circle>
//     </svg>
//   );
// };

const LoadingCpn = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      width="200"
      height="200"
      className={`${className || ""}`}
      style={{
        shapeRendering: "auto",
        display: "block",
        background: "rgb(255, 255, 255, 0)",
        ...style,
      }}
      // xmlns:xlink='http://www.w3.org/1999/xlink'
    >
      <g>
        <circle fill="#ba68c8" r="10" cy="50" cx="84">
          <animate
            begin="0s"
            keySplines="0 0.5 0.5 1"
            values="10;0"
            keyTimes="0;1"
            calcMode="spline"
            dur="0.25s"
            repeatCount="indefinite"
            attributeName="r"
          ></animate>
          <animate
            begin="0s"
            values="#ba68c8;#f6e659;#ce93d8;#fff176;#ba68c8"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="discrete"
            dur="1s"
            repeatCount="indefinite"
            attributeName="fill"
          ></animate>
        </circle>
        <circle fill="#ba68c8" r="10" cy="50" cx="16">
          <animate
            begin="0s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="r"
          ></animate>
          <animate
            begin="0s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="cx"
          ></animate>
        </circle>
        <circle fill="#fff176" r="10" cy="50" cx="50">
          <animate
            begin="-0.25s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="r"
          ></animate>
          <animate
            begin="-0.25s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="cx"
          ></animate>
        </circle>
        <circle fill="#ce93d8" r="10" cy="50" cx="84">
          <animate
            begin="-0.5s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="r"
          ></animate>
          <animate
            begin="-0.5s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="cx"
          ></animate>
        </circle>
        <circle fill="#f6e659" r="10" cy="50" cx="16">
          <animate
            begin="-0.75s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="r"
          ></animate>
          <animate
            begin="-0.75s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="1s"
            repeatCount="indefinite"
            attributeName="cx"
          ></animate>
        </circle>
        <g></g>
      </g>
    </svg>
  );
};

export default LoadingCpn;
